import { BaSeButton, BaSeParagraph } from '@base/react';
import React from 'react';

import { FormContext } from '../../hook/form-context';
import EmpretecCard from './EmpretecCard';
import { AlignButton, Container, ContainerText, Content } from './style';

import { MAP_EMPRETEC } from '../../data/empretecData';

function KnowEmpretec() {
  const { handleMenuClick } = React.useContext(FormContext);

  return (
    <Container id="2">
      <ContainerText>
        <BaSeParagraph>
          Conheça as versões do <strong>Empretec</strong> mais adequada para
          você
        </BaSeParagraph>
      </ContainerText>

      <Content>
        {MAP_EMPRETEC.map((empretec) => (
          <EmpretecCard
            bgButtonColor={empretec.bgButtonColor}
            foregroundColor={empretec.foregroundColor}
            key={empretec.moduleId}
            moduleId={empretec.moduleId}
            bgColor={empretec.bgColor}
            bgColorInformations={empretec.bgColorInformations}
            imgEmpretecLargeDisplay={empretec.imgEmpretecLargeDisplay}
            imgEmpretecSmallDisplay={empretec.imgEmpretecSmallDisplay}
            logoEmpretec={empretec.logoEmpretec}
            textColor={empretec.textColor}
            description={empretec.description}
          />
        ))}
      </Content>

      <AlignButton>
        <BaSeButton
          borderRadius="max"
          isBold
          onClick={() => handleMenuClick('7')}
          color="#0000C9"
          size="big"
          value="Tenho interesse em participar"
        />
      </AlignButton>
    </Container>
  );
}

export default KnowEmpretec;
